import { instance, mstance, starInstance, starPlanInstance } from './instance';

export const $get = (url, params = {}, config = {}) => {
  return instance.get(url, { params, ...config });
};

export const $post = (url, data = {}, config) => {
  return instance.post(url, data, config);
};
//java star请求
export const $starGet = (url, params = {}, config = {}) => {
  return starInstance.get(url, { params, ...config });
};
//激励数据请求接口
export const $movaGet = (url, params = {}, config = {}) => {
  return mstance.get(url, { params, ...config });
};
export const $planPost = (url, data = {}, config) => {
  return starPlanInstance.post(url, data, config);
};
